import { Bets } from '../../../config/bets';
import { useGameSelector } from '../../../store/GameStore';
import { AutoCashoutObjProps } from './types';

export const useAutoCashoutSlice = {
  isEnabled: (betCode: Bets): boolean => {
    return useGameSelector(({ autoCashout }) => autoCashout[betCode].isEnabled);
  },
  getAutoCashoutObj: (betCode: Bets): AutoCashoutObjProps => {
    return useGameSelector(({ autoCashout }) => autoCashout[betCode]);
  },
  getLastValue: (betCode: Bets): string => {
    return useGameSelector(({ autoCashout }) => autoCashout[betCode].lastValue);
  }
};
